import { Grid, Typography } from "@mui/material";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import {
  DateInput,
  RadioInput,
  TextInput,
} from "../../../../../components/inputs";

const ExistingDocForm1 = () => {
  const isJoint = useSelector((state) => state?.instruction?.isJoint);
  const arr = useSelector((state) => state?.instruction?.arr);
  const [edit, setEdit] = useState(arr.length > 1 ? [false, false] : [false]);
  const { living_will_q_consiousness } = useSelector(
    (state) => state?.lookupData
  );
  const handleEdit = (clientNumber, value) => {
    setEdit((prev) => {
      let temp = prev;
      temp[clientNumber] = value;
      return [...temp];
    });
  };
  return (
    <>
      <Grid item xs={12}>
        <Typography
          variant="h6"
          style={{ fontSize: "bold", marginBottom: "0.5rem" }}
        >
          Existing Docs
        </Typography>
      </Grid>
      <Grid width={"100%"} display={"flex"} flexDirection={"row"}>
        {arr?.map((item, index) => {
          return (
            <Grid
              width={isJoint ? "50%" : "100%"}
              borderTop={`1px solid #DCDCE1`}
              borderBottom={`1px solid #DCDCE1`}
              borderRight={index === 0 ? `1px solid #DCDCE1` : null}
              paddingY={4}
              display={"flex"}
              flexDirection={"column"}
              gap={3}
              paddingRight={index === 0 ? 2 : 0}
              paddingLeft={index === 1 ? 2 : 0}
            >
              <Grid container spacing={3}>
                <Grid item xs={6}>
                  <RadioInput
                    orientation="row"
                    label={`Has the Testator previously made a Living Will?`}
                    name={`InstructionLivingWillQuestionnaire.[${index}].existingDocs.hasTestatorMadeLivingWill.value`}
                    options={[
                      { label: "Yes", value: true },
                      { label: "No", value: false },
                    ]}
                  />
                </Grid>

                <Grid item xs={6} pr={1}>
                  <DateInput
                    name={`InstructionLivingWillQuestionnaire.[${index}].existingDocs.hasTestatorMadeLivingWill.livingWillDate`}
                    label={`If yes, mention date`}
                  />
                </Grid>

                <Grid item xs={6}>
                  <RadioInput
                    orientation="row"
                    label={`Has the Testator previously made an Advance Statement?`}
                    name={`InstructionLivingWillQuestionnaire.[${index}].existingDocs.hasTestatorMadeAdvanceStatement.value`}
                    options={[
                      { label: "Yes", value: "true" },
                      { label: "No", value: "false" },
                    ]}
                  />
                </Grid>

                <Grid item xs={6} pr={1}>
                  <DateInput
                    name={`InstructionLivingWillQuestionnaire.[${index}].existingDocs.hasTestatorMadeAdvanceStatement.advanceStatementDate`}
                    label={`If yes, mention date`}
                  />
                </Grid>

                <Grid item xs={6}>
                  <RadioInput
                    orientation="row"
                    label={`Has the Testator previously made a Health and Welfare LPA?`}
                    name={`InstructionLivingWillQuestionnaire.[${index}].existingDocs.hasTestatorMadeHealthAndWelfareLPA.value`}
                    options={[
                      { label: "Yes", value: true },
                      { label: "No", value: false },
                    ]}
                  />
                </Grid>
                <Grid item xs={6} pr={1}>
                  <TextInput
                    name={`InstructionLivingWillQuestionnaire.[${index}].existingDocs.hasTestatorMadeHealthAndWelfareLPA.whoAreAttorneys`}
                    label="If yes, who are the attorneys?"
                    placeholder="If yes, who are the attorneys?"
                  />
                </Grid>
              </Grid>
            </Grid>
          );
        })}
      </Grid>
    </>
  );
};

export default ExistingDocForm1;
